import { useCallback, useEffect, useMemo, useState } from 'react';
import { IconButton, Input, Select } from '../../../layout/form';
import { logOut, registerRoutes } from '../../../func';
import { useRouteMatch } from 'react-router-dom/cjs/react-router-dom.min';
import { useDispatch } from 'react-redux';
import axios from 'axios';

const AddressTab = ({ buyingGroup, refetch }) => {
  const { path } = useRouteMatch();
  const dispatch = useDispatch();
  const authData = useMemo(
    () => JSON.parse(localStorage.getItem('auth_data')),
    []
  );

  const initValues = useCallback(
    () => ({
      addressLineOne: buyingGroup.addressLineOne || '',
      addressLineTwo: buyingGroup.addressLineTwo || '',
      city: buyingGroup.city || '',
      stateId: buyingGroup.stateId || '',
      zip: buyingGroup.zip || '',
    }),
    [buyingGroup]
  );

  const [stateList, setStateList] = useState([]);
  const [isEditing, setIsEditing] = useState(false);
  const [values, setValues] = useState(initValues());

  const networkCalls = useMemo(
    () =>
      registerRoutes(
        {
          getStateList: {
            func: () => {
              axios
                .get('/api/v1/state/read/all', {
                  params: authData,
                })
                .then(result => setStateList(result.data))
                .catch(logOut);
            },
          },
          update: {
            func: values => {
              axios
                .put('/api/v2/buyinggroup/update/one/by/id', {
                  ...authData,
                  ...values,
                })
                .then(result => {
                  dispatch(result.data);
                  refetch();
                })
                .catch(logOut);
            },
          },
        },
        path
      ),
    [path, dispatch, authData]
  );

  const onChange = ({ target: { id, value } }) =>
    setValues(prev => ({ ...prev, [id]: value }));

  const edit = () => {
    setValues(initValues());
    setIsEditing(true);
  };

  const update = useCallback(() => {
    const { id, name, phone, email, website } = buyingGroup;

    const obj = {
      ...values,
      buyingGroupId: id,
      name,
      phone,
      email,
      website,
      stateId: values.stateId || null,
    };

    networkCalls.update(obj);
  }, [values, buyingGroup]);

  const autoAdjustHeight = () => {
    const labelElements = document.querySelectorAll('table#t-labels>tbody>tr');
    const valueElements = document.querySelectorAll('table#t-values>tbody>tr');

    labelElements.forEach((el, index) => {
      valueElements[index].style.height = `${el.clientHeight}px`;
    });
  };

  useEffect(() => {
    autoAdjustHeight();
  }, [buyingGroup]);

  useEffect(() => {
    networkCalls.getStateList();
    window.addEventListener('resize', autoAdjustHeight);
    return () => {
      window.removeEventListener('resize', autoAdjustHeight);
    };
  }, []);

  return (
    <div style={{ padding: '1vw' }}>
      <div className="row">
        <IconButton icon="edit" onClick={edit} />
      </div>
      <div className="row">
        <div className="col s4 m3 l2">
          <table id="t-labels">
            <tbody>
              <tr>
                <td
                  className="bold"
                  style={{ textAlign: 'right', padding: '4px' }}
                >
                  Address Line One
                </td>
              </tr>
              <tr>
                <td
                  className="bold"
                  style={{ textAlign: 'right', padding: '4px' }}
                >
                  Address Line Two
                </td>{' '}
              </tr>
              <tr>
                <td
                  className="bold"
                  style={{ textAlign: 'right', padding: '4px' }}
                >
                  City
                </td>{' '}
              </tr>
              <tr>
                <td
                  className="bold"
                  style={{ textAlign: 'right', padding: '4px' }}
                >
                  State
                </td>
              </tr>
              <tr>
                <td
                  className="bold"
                  style={{ textAlign: 'right', padding: '4px' }}
                >
                  Zip
                </td>{' '}
              </tr>
            </tbody>
          </table>
        </div>
        <div className="col s8 m9 l10">
          {buyingGroup ? (
            <table id="t-values" className="highlight">
              {isEditing ? (
                <tbody>
                  <Input
                    id="addressLineOne"
                    value={values.addressLineOne}
                    onChange={onChange}
                  />
                  <Input
                    id="addressLineTwo"
                    value={values.addressLineTwo}
                    onChange={onChange}
                  />
                  <Input id="city" value={values.city} onChange={onChange} />
                  <Select
                    id="stateId"
                    value={values.stateId}
                    onChange={onChange}
                    options={stateList?.map(({ id, name, code }) => ({
                      value: id,
                      label: `${name} - ${code}`,
                    }))}
                  />
                  <Input id="zip" value={values.zip} onChange={onChange} />
                </tbody>
              ) : (
                <tbody>
                  <tr>
                    <td style={{ padding: '4px' }}>
                      {buyingGroup.addressLineOne || ''}
                    </td>
                  </tr>
                  <tr>
                    <td style={{ padding: '4px' }}>
                      {buyingGroup.addressLineTwo || ''}
                    </td>
                  </tr>
                  <tr>
                    <td style={{ padding: '4px' }}>{buyingGroup.city || ''}</td>
                  </tr>
                  <tr>
                    <td style={{ padding: '4px' }}>
                      {buyingGroup.state?.name || ''}
                    </td>
                  </tr>
                  <tr>
                    <td style={{ padding: '4px' }}>{buyingGroup.zip || ''}</td>
                  </tr>
                </tbody>
              )}
            </table>
          ) : null}
        </div>
      </div>
      {isEditing ? (
        <div className="row">
          <IconButton icon="cancel" onClick={() => setIsEditing(false)} />
          <IconButton icon="save" onClick={update} />
        </div>
      ) : null}
    </div>
  );
};

export default AddressTab;
